import React from 'react';
import iconMap from './FocusIcons';
import ArrowIcon from '../shared/ArrowIcon';

function FocusCard({ title, desc, gradient, delay, iconType }) {
  const IconComponent = iconMap[iconType];

  return (
    <div className={`focus-card reveal reveal-${delay}`}>
      <div className="focus-card-visual">
        <div
          className="focus-card-bg"
          style={{ background: `radial-gradient(circle, ${gradient}, transparent)` }}
        />
        <div className="focus-card-icon">
          {IconComponent && <IconComponent />}
        </div>
      </div>
      <div className="focus-card-content">
        <h3 className="focus-card-title">{title}</h3>
        <p className="focus-card-desc">{desc}</p>
        <div className="focus-card-arrow">
          Learn More <ArrowIcon size={16} />
        </div>
      </div>
    </div>
  );
}

export default FocusCard;
